// import Cookies from 'js-cookie'

const app = {
  state: {
    dialogKf: false,
    device: 'desktop',  // 当前设备类型
    sidebar: {
      // opened: !+Cookies.get('sidebarStatus'),
      opened: true,
      withoutAnimation: false,
    },
  },
  mutations: {
    TOGGLE_SIDEBAR: (state) => {
      // if (state.sidebar.opened) {
      //   Cookies.set('sidebarStatus', 1)
      // }
      // else {
      //   Cookies.set('sidebarStatus', 0)
      // }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      // Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    SHOW_SIDEBAR: (state, withoutAnimation) => {
      state.sidebar.opened = true
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    OPEN_DIALOG_KF: (state) => {
      state.dialogKf = true
    },
    CLOSE_DIALOG_KF: (state) => {
      state.dialogKf = false
    },
    
    // SET_OEM: (state, {logo, oem_id}) => {
    //   state.is_oem = true
    //   state.oem_logo = logo
    //   state.oem_id = oem_id
    // }
  },
  actions: {
    // 切换sidebar（调用一次取反一次）
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    // 收起sidebar
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    // 展开sidebar
    showSideBar({ commit }, { withoutAnimation }) {
      commit('SHOW_SIDEBAR', withoutAnimation)
    },
    // 切换设备类型
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
  },
}

export default app
